export default __webpack_public_path__ + "static/media/facebook_avert.40e9b918.png";